var ol = require('../dist/ol-debug');
ol.interaction.DragPan.prototype.handleDownEvent = function(mapBrowserEvent) {
    if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        this.lastCentroid = null;

        if (view.getAnimating()) {
            if (Math.floor(view.getZoom()) !== view.getZoom()) {
                return false;
            }
        }

        // stop any current animation
        if (view.getAnimating()) {
            view.setCenter(mapBrowserEvent.frameState.viewState.center);
        }
        if (this.kinetic_) {
            this.kinetic_.begin();
        }
        // No kinetic as soon as more than one pointer on the screen is
        // detected. This is to prevent nasty pans after pinch.
        this.noKinetic_ = this.targetPointers.length > 1;
        return true;
    } else {
        return false;
    }
}




//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/fixfloatzoom.js
// module id = 28
// module chunks = 0